
import axios from 'axios'
import { url } from '@/config'
const axiosInstance = axios.create({
  baseURL: url,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json'
  }
})

class AuthProvider {
  getStore (payload) {
    return axiosInstance.post(`/users`, {
      ...payload
    })
  }
}

export default AuthProvider
